<template>
    <div>
        <el-dialog
            :visible.sync="show"
            :destroy-on-close="true"
            :before-close="handleClose"
            width="900px"
            title="医案打印预览"
            class="print-dialog"
        >
            <div class="content" style="overflow: auto; position: relative;overflow-y:scroll; height:500px">
                <el-button v-print='printOption'  @click=" printBtn" size="mini" style="background: #409EFF; color: #fff; border: 0" >打印</el-button >
                <div ref='print_info' id="qrCode">
                    <div class="firchuf" style="mine-height:600px;padding-bottom:60px;padding-top:20px">
                        <div style="position: relative; line-height: 50px;">
                            <div style=" text-align: center;font-size: 20px;  color: #409EFF; margin-bottom:20px" > 处方 </div>
                                <span style=" font-size: 12px; color: #666;  position: absolute;  left: 19px; top: 6px; " >正方</span >
                        </div>
                        <printInfo :patientInfo="patientInfo"></printInfo>
                    </div>
                    <!-- 底方 -->
                    <div class="firchuf" >
                        <div style="position: relative; line-height: 50px; ">
                            <div style="text-align: center;font-size: 20px;  color: #409EFF; margin:20px 0 " > 处方 </div>
                                <span style=" font-size: 12px; color: #666;  position: absolute;  left: 19px; top: 6px; " >底方</span >
                        </div>
                        <printInfo :patientInfo="patientInfo"></printInfo>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import printInfo from "./print_info.vue"
export default {
    props: ['show','patientInfo',''],
    components: {
      printInfo  
    },
    data () {
        return {
            getTimer:'',
            printOption:{
                id:'qrCode',
                popTitle:'',
            }
        }
    },
   
    methods: {
        
        //打印按钮
        printBtn() {
            // 打印不全
            // this.$print(this.$refs.print_info)
            // var newWin = window.open(""); //新打开一个空窗口
            // var imageToPrint = document.getElementById("qrCode"); //将要被打印的图片
            // newWin.document.write(imageToPrint.outerHTML); //将图片添加进新的窗口
            // newWin.document.close(); //在IE浏览器中使用必须添加这一句
            // newWin.focus(); //在IE浏览器中使用必须添加这一句
            // setTimeout(function () {
            //     newWin.print(); //打印
            //     newWin.close(); //关闭窗口
            // }, 100);
        },
        handleClose(){
            this.$emit('update:show',false)
        }
    }
}
</script>

<style lang='less'>
   
</style>